export const API_URL = 'https://api.jobhunter.ovh';
